<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const { content, sender, contentAttributes } = useMessageContext();
const { t } = useI18n();

const meetingUrl = computed(() => {
  const data = contentAttributes.value?.data;
  return data?.meetingUrl || data?.meeting_url || '';
});

const senderName = computed(() => {
  return sender?.value?.name || '';
});
</script>

<template>
  <BaseBubble class="overflow-hidden p-3" data-bubble-name="jitsi">
    <div class="grid gap-4 min-w-64">
      <div class="grid gap-3">
        <div class="size-8 rounded-lg grid place-content-center bg-blue-600">
          <Icon icon="i-ph-video-camera-fill" class="text-white size-4" />
        </div>
        <div class="space-y-1 overflow-hidden">
          <div v-if="senderName" class="text-n-slate-12 text-sm truncate">
            {{
              t('CONVERSATION.SHARED_ATTACHMENT.MEETING', {
                sender: senderName,
              })
            }}
          </div>
          <div v-else-if="content" class="text-sm truncate text-n-slate-12">
            {{ content }}
          </div>
        </div>
      </div>
      <div v-if="meetingUrl" class="mb-2">
        <a
          :href="meetingUrl"
          rel="noreferrer noopener nofollow"
          target="_blank"
          class="w-full block bg-n-solid-3 px-4 py-2 rounded-lg text-sm text-center border border-n-container"
        >
          {{ t('INTEGRATION_SETTINGS.JITSI.CLICK_HERE_TO_JOIN') }}
        </a>
      </div>
    </div>
  </BaseBubble>
</template>
